// import Dashboard from "./dashboard";
import GetRestaurant from "./getAllRestaurantList";
import Diner from './diner'
import MenuType from "./menutype";
import Category from "./category";
import FoodDrink from "./foodDrink";
import Account from "./account";
import User from "./user"
import Asset from "./assets";
import PublicClient from "./publicClient";
import LoyaltyAdmin from "./loyaltyAdmin";
export default (store) => ({
  // dashboard: new Dashboard(store),
    getRestaurant: new GetRestaurant(store),
    loyaltyAdmin: new LoyaltyAdmin(store),
    menuType: new MenuType(store),
    category: new Category(store),
    foodDrink: new FoodDrink(store),
    diner: new Diner(store),
    account: new Account(store),
    user: new User(store),
    asset: new Asset(store),
    publicClient: new PublicClient(store),
})
